import { render, staticRenderFns } from "./SegundaViaObito.vue?vue&type=template&id=23db8207&"
import script from "./SegundaViaObito.vue?vue&type=script&lang=js&"
export * from "./SegundaViaObito.vue?vue&type=script&lang=js&"
import style0 from "./SegundaViaObito.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports